import I18N from '@leverege/i18n';
import EditSettingsAction from "../../../actions/EditSettingsAction.js";
const {
  tf
} = I18N.ns('molten.dataViewers.map.EditSettingsAction');
export default new EditSettingsAction({
  id: 'molten.dataViewers.map.EditSettingsAction',
  matches: {
    use: 'bottomRightActionBar',
    client: ['MapDataViewer', 'GoogleMapsDataViewer']
  },
  title: tf('title'),
  handles: context => {
    const {
      streetView
    } = context;
    return !streetView;
  },
  versionPath: opts => {
    const path = opts?.context?.clientProps?.relationship?.path;
    const client = opts?.context?.client === 'GoogleMapsDataViewer' ? '.GoogleMapsDataViewer' : '';
    return path ? `${path}.mapViewerModel${client}` : null;
  },
  editorProps: ({
    context
  }) => {
    const {
      objectType,
      delegate,
      relationship,
      dataViewerCardModel,
      parentItem
    } = context?.clientProps || {};
    return {
      objectType,
      delegate,
      relationship,
      dataViewerCardModel,
      parentItem
    };
  }
});